<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <account-header settingName="Reciept"></account-header>
    <div class="row justify-center">
      <div class="col-lg-2"></div>
      <div class="col-lg-8">
        <!-- <div class="row mt-4 mb-4"> -->
          <div class="col-md-12">
            <div class="section padding-top z-bigger">
              <div class="container">
                <div class="row justify-content-center padding-bottom-smaller">
                   <div class="col-12">
                        <div class="room-box background-grey">
                            <div style="display: flex">
                                <div class="col-6 offset-3 text-center pt-4" style="padding: 0">
                                    <h3>{{ reciept.message }}</h3>
                                    <p>Your transaction id is {{ reciept.transactionReference }}</p>
                                    <p>You didn't get your reciept ?</p>
                                    <p>You  can download your reciept below</p>
                                    <div class="col-12 mb-4">
                                        <button type="button" class="btn btn-info float-left  mb-4" @click="goBackToRooms($event)">Go to Rooms</button>
                                        <!-- <button type="button" class="btn btn-success float-right  mb-4" @click="submitDetails($event, reciept.transactionId)">Download Reciept</button> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                   </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery'
import Constants from '@/common/Constants.js'
import accountHeader from "@/components/accountHeader.vue";

export default {
  name: "reciept",
  data(){
    return {
      reciept : {
        
      }
    }
  },
  created(){
    if(localStorage.transaction){
       this.reciept = JSON.parse(localStorage.transaction);
    }else{
        this.$router.go(-1);
    }
  },
  mounted(){
    let loaderContainer = $('.loader');
    let loader = $('.loader__figure');
    loaderContainer.attr("style", "display:none");
    loader.attr("style", "display:none");
  },
  components: { "account-header": accountHeader },
  methods : {
     goBackToRooms(event){
       this.$router.push('/rooms');
    }
  }

  // components: {
  //   headerNav
  // }
};
</script>
<style scoped>
#flight-datepicker input{
    color: #737373 !important;
    border-right:0;
    text-align: center;
    border-left:0;
    border-top:0;
    border-bottom: 1px solid rgba(200, 200, 200, .7);

    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 15px;
    line-height: 1.7;
    font: 400 13.3333px Arial;
    text-transform: none;
    
}
#flight-datepicker input:focus,
#flight-datepicker input:active{
	border-color: #6dc234;
} 

#flight-datepicker input::placeholder {
  color: #999999;
}
.label{
  text-align: center;
  align-content: center;
  margin-top: 10px;
}
</style>

